{
  "rwg-cancel-request-page": {
    "buttons": {
      "cancel": "Cancel",
      "submit": "Submit",
      "to-home-page": "To home page"
    },
    "meta": {
      "title": "Beauty Pro - Request to deactivate the Google integration",
      "description": "Fill out the following form to request the deactivation of our Google integration on your Google map"
    },
    "text": {
      "title": "Request to deactivate the Google integration",
      "subtitle-salon-info": "Where is your salon?",
      "subtitle-owner-info": "How can we contact to you?",
      "email": "Your email",
      "full-name": "Your full name",
      "language": "Your preferred language for communication",
      "request-sent-success": "Your request was sent successfully!",
      "request-confirmation-sent-to-your-email": "Our confirmation will be sent to your e-mail. Please also check your spam folder!",
      "salon-address": "Your salon address",
      "salon-name": "Your salon name",
      "we-will-contact-soon": "Our team is eager to assist you, and we will be in touch shortly to address your request."
    }
  }
}
